<script>
import Vue from 'vue';

export default {

    data() {
        return {
            open: false,
            current: 0
        }
    },

    props: {
        suggestions: {
            type: Array,
            required: true
        },

        selection: {
            type: String,
            required: true,
            twoWay: true
        }
    },

    computed: {
        matches() {
            return this.suggestions.filter((item) => {
                console.log(this.selection);
                var nombreLower = this.selection.toLowerCase();
                var itemLower = item.nombre.toLowerCase();
                return itemLower.indexOf(nombreLower) >= 0;
                //return item.nombre.indexOf(this.selection) >= 0;
            });
        },

        openSuggestion() {
            return this.selection !== "" &&
                   this.matches.length != 0 &&
                   this.open === true;
        }
    },

    methods: {
        enter() {
            this.selection = this.matches[this.current].nombre;
            this.open = false;
        },

        up() {
            if(this.current > 0)
                this.current--;
        },

        down() {
            if(this.current < this.matches.length - 1)
                this.current++;
        },

        isActive(index) {
            return index === this.current;
        },

        change() {
            if (this.open == false) {
                this.open = true;
                this.current = 0;
            }
        },

        suggestionClick(index) {
            var ss = this.matches[index].key_src;
            console.log(ss);
            var cc = this.matches[index].nombre;
            console.log(cc);
            this.selection = cc;
            this.$emit('selected', ss);
            this.open = false;
        },
    }
}

</script>
<template>

<div style="position:relative" v-bind:class="{'open':openSuggestion}" class="input-field">
    <input  type="text" v-model="selection"
        @keydown.enter = 'enter'
        @keydown.down = 'down'
        @keydown.up = 'up'
        @input = 'change'
        style="color: black;"
    />
    <ul class="autocomplete-results" style="width:100%" v-if="openSuggestion" >

        <li v-for="(suggestion, index) in matches"
            v-bind:key="index"
            v-bind:class="{'active': isActive(index)}"
            @click="suggestionClick(index)" class="autocomplete-result"
        >
            <a href="#">{{ suggestion.nombre }}</a>
        </li>
    </ul>
</div>
</template>
<style>

.autocomplete {
  position: relative;
  width: 130px;
}

.autocomplete-results {
  padding: 0;
  margin: 0;
  border: 1px solid #eeeeee;
  height: 120px;
  overflow: auto;
  width: 100%;
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
}

.autocomplete-result.is-active,
.autocomplete-result:hover {
  background-color: #4aae9b;
  color: white;
}
</style>